(function () {
	const facetsMenu = () => {
		$('html.js .no_submit').click(function(e){
			e.preventDefault();
		})

		function setInert(inert) {
			var target = document.getElementById('facets-menu');
			if (!target) return;

			// Walk up from #facets-menu to <body>, inerting all siblings at each level
			var current = target;
			while (current.parentElement && current.parentElement !== document.documentElement) {
				var siblings = current.parentElement.children;
				for (var i = 0; i < siblings.length; i++) {
					if (siblings[i] !== current && siblings[i].tagName !== 'SCRIPT') {
						if (inert) {
							siblings[i].setAttribute('inert', '');
							siblings[i].setAttribute('aria-hidden', 'true');
						} else {
							siblings[i].removeAttribute('inert');
							siblings[i].removeAttribute('aria-hidden');
						}
					}
				}
				current = current.parentElement;
			}
		}

		var focusTrapHandler = null;

		function trapFocus(container) {
			var focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

			focusTrapHandler = function(e) {
				if (e.key !== 'Tab') return;

				var focusable = container.querySelectorAll(focusableSelector);
				var visible = [];
				for (var i = 0; i < focusable.length; i++) {
					if (focusable[i].offsetParent !== null) visible.push(focusable[i]);
				}
				if (visible.length === 0) return;

				var first = visible[0];
				var last = visible[visible.length - 1];

				if (e.shiftKey && document.activeElement === first) {
					e.preventDefault();
					last.focus();
				} else if (!e.shiftKey && document.activeElement === last) {
					e.preventDefault();
					first.focus();
				}
			};

			document.addEventListener('keydown', focusTrapHandler);
		}

		function releaseFocusTrap() {
			if (focusTrapHandler) {
				document.removeEventListener('keydown', focusTrapHandler);
				focusTrapHandler = null;
			}
		}

		$('#facets-menu').on('keydown', 'input[type="checkbox"]', function(e) {
		if (e.key === 'Enter') {
			e.preventDefault();
		}
	});

	$('.open_filters').click(function(){
			$('#open_filters_menu').addClass('show_menu');
			$('body').addClass('overflow-hidden');
			document.getElementById('facets-menu').removeAttribute('inert');
			setInert(true);
			trapFocus(document.getElementById('facets-menu'));
			$('.facets-menu__close').focus();
		})

		function closeMenu() {
			if (!$('#open_filters_menu').hasClass('show_menu')) return;
			$('#open_filters_menu').removeClass('show_menu');
			$('body').removeClass('overflow-hidden');
			releaseFocusTrap();
			setInert(false);
			document.getElementById('facets-menu').setAttribute('inert', '');

			// Apply filter DOM updates that were deferred while the dialog was open
			if (typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm.applyPendingFilters) {
				FacetFiltersForm.applyPendingFilters();
			}

			requestAnimationFrame(function() {
				$('.open_filters').focus();
			});
		}

		$('#facets-menu').on('click', '.facets-menu__close,.facets__submit,.facets__reset', function(){
			closeMenu();
		})

		$(document).on('keydown', function(e) {
			if (e.key === 'Escape') {
				closeMenu();
			}
		})

		$(document).on('click', function(e) {
			if (!$('#open_filters_menu').hasClass('show_menu')) return;
			var facetsMenu = document.getElementById('facets-menu');
			if (!facetsMenu) return;
			if (!facetsMenu.contains(e.target) && !$(e.target).closest('.open_filters').length) {
				closeMenu();
			}
		})
	};

	document.addEventListener("DOMContentLoaded", function () {
		facetsMenu();
	});
	document.addEventListener("shopify:section:load", function () {
		facetsMenu();
	});
})();
